export const BV_SUCESSFULLY_VERIFIED_BENEFITS = [
  "You messaging limit has been increased to 1000.",
  "Your display name is auto-approved.",
  "You are qualified to applied for the green tick.",
  "Your Meta’s business verification has been successfully completed.",
];
